// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2blLi","disabled":"FileBtn_disabled__2zXaU","warn":"FileBtn_warn__3VCPb","fade":"FileBtn_fade__1nNQK"};